import { Action, configureStore, Reducer, ReducersMapObject, ThunkAction } from '@reduxjs/toolkit';
// eslint-disable-next-line dmtrs-fsd-path-checker/layer-imports
import { authReducer } from '@/features/Auth';
// eslint-disable-next-line dmtrs-fsd-path-checker/layer-imports
import { adminReducer } from '@/entities/Admin';
import { rtkApi } from '@/shared/api/rtkApi';
import { $api } from '@/shared/api/api';
import { StateSchema, ThunkExtraArg } from '../../types/store';
import { createReducerManager } from './reducerManager';

export function createReduxStore(initialState?: StateSchema) {
  const rootReducers: ReducersMapObject<StateSchema> = {
    admin: adminReducer,
    authForm: authReducer,
    [rtkApi.reducerPath]: rtkApi.reducer,
  };

  const reducerManager = createReducerManager(rootReducers);

  const extraArg: ThunkExtraArg = {
    api: $api,
  };

  const store = configureStore({
    reducer: reducerManager.reduce as Reducer<StateSchema>,
    preloadedState: initialState,
    // devTools: __IS_DEV__,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        thunk: {
          extraArgument: extraArg,
        },
      }).concat(rtkApi.middleware),
  });

  // @ts-ignore
  store.reducerManager = reducerManager;

  return store;
}

export type AppStore = ReturnType<typeof createReduxStore>;
export type AppState = ReturnType<AppStore['getState']>;
export type AppDispatch = ReturnType<typeof createReduxStore>['dispatch'];
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, AppState, unknown, Action>;
